'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (redirectTo) {
  return function (nextState, replaceState) {
    if (__SERVER__ || __TEST__) {
      if (typeof redirectTo === 'function') {
        replaceState(redirectTo(nextState.location));
      } else {
        replaceState(redirectTo);
      }
    }
  };
};